import {svgIconWrapper} from '../svg-icon-wrapper';

import EyeSolid from './eye-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EyeSolid {...validProps} />;
}

SvgComponent.iconName = 'eyeSolid';

export const EyeSolidIcon = svgIconWrapper(SvgComponent);
